import { useFormContext, useFormState } from 'react-hook-form';

import { Typography } from 'antd';

interface IProps {
  fieldName: string;
  hide?: boolean;
}

export function ErrorMessage({ fieldName, hide = false }: IProps) {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const message = errors[fieldName]?.message as string | undefined;

  if (!message || hide) {
    return null;
  }

  return (
    <Typography.Text type='danger' className='mt-1 block text-sm'>
      {message}
    </Typography.Text>
  );
}
